type OnePanelTransitionPrewarmOptions = {
    currentIndex: number
    isMobile: boolean
    numPanels: number
    speed: number
    targetEmpty?: boolean
    targetExists: boolean
    targetIndex: number
}

type OnePanelGesturePrewarmOptions = {
    currentIndex: number
    direction?: 'next' | 'prev'
    isMobile: boolean
    numPanels: number
    panelCount: number
}

export function shouldPrewarmOnePanelTransition({
    currentIndex,
    isMobile,
    numPanels,
    speed,
    targetEmpty = false,
    targetExists,
    targetIndex,
}: OnePanelTransitionPrewarmOptions) {
    return (
        !isMobile &&
        numPanels === 1 &&
        speed > 0 &&
        targetExists &&
        !targetEmpty &&
        targetIndex !== currentIndex
    )
}

export function resolveOnePanelGesturePrewarmTarget({
    currentIndex,
    direction,
    isMobile,
    numPanels,
    panelCount,
}: OnePanelGesturePrewarmOptions) {
    if (isMobile || numPanels !== 1 || (direction !== 'next' && direction !== 'prev')) {
        return null
    }

    const targetIndex = currentIndex + (direction === 'next' ? 1 : -1)
    return targetIndex >= 0 && targetIndex < panelCount ? targetIndex : null
}
